<div class="modal-content">
  @if (!error) {
    <!--Header-->
    <div
      class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
    >
      <div class="modal-title">
        <h4 class="mb-0">
          {{ exit_kiosk ? "Exit Kiosk Mode" : "Confirm Cancellation" }}
        </h4>
      </div>
      @if (this.sharedService.kiosk_mode === true) {
        <button
          type="button"
          class="close-btn"
          style="margin-left: auto"
          (click)="cancelClick()"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      }
    </div>

    <!--Body-->
    <div class="modal-body pb-4">
      @if (!exit_kiosk) {
        <div class="text-center mt-3">
          <p class="mb-1" style="font-size: 1.1rem">
            Would you like to cancel this form?
          </p>
          <p class="text-light mb-4">All data will be lost if canceled.</p>
          <div class="d-flex justify-content-between px-5">
            <button
              class="btn modern-btn secondary-btn"
              style="width: 150px"
              (click)="cancelClick()"
            >
              {{ cancel_button || "Cancel" }}
            </button>
            <button
              class="btn modern-btn primary-btn"
              style="width: 150px"
              (click)="okClick()"
            >
              {{ ok_button || "OK" }}
            </button>
          </div>
        </div>
      }

      @if (exit_kiosk) {
        <div class="d-flex flex-column gap-3 mt-3">
          <div class="row align-items-center">
            <label
              for="email"
              class="col-sm-4 col-form-label form-label text-end mb-0"
              >Email:</label
            >
            <div class="col-sm-8 flex-grow-1">
              <input style="display: none" type="email" name="fakeemail" />
              <input style="display: none" type="password" name="fakepassword" />
              <input
                class="form-control modern-input w-100"
                id="email"
                name="email"
                type="email"
                autocomplete="new-password"
              />
            </div>
          </div>
          <div class="row align-items-center">
            <label
              for="password"
              class="col-sm-4 col-form-label form-label text-end mb-0"
              >Password:</label
            >
            <div class="col-sm-8 flex-grow-1">
              <input
                class="form-control modern-input w-100"
                type="password"
                id="password"
                name="password"
                autocomplete="new-password"
              />
            </div>
          </div>

          <div class="d-flex justify-content-end mt-4">
            <button
              class="btn modern-btn primary-btn px-5 w-100"
              (click)="exitKiosk()"
            >
              Exit Kiosk
            </button>
          </div>
        </div>
      }
    </div>
  }

  @if (error) {
    <div class="modal-body pb-4 text-center">
      <p class="text-danger mb-0 mt-3">{{ error_message }}</p>
    </div>
  }
</div>
